import React from 'react'
import { Table } from 'react-bootstrap'
import { MYSTERY_BOX_ITEM, ORDER_ITEM_TYPE, BOX_PICKER_NAME } from '../../constants/item'

export default function OrderItemsDataTable({ order, orderType }) {
  const roundNoAndSeriesNo = (id) => {
    if (id) {
      return { roundNo: id.slice(3, 5), seriesNo: id.slice(6, 8) }
    }
    return null
  }

  const renderHeader = () => {
    return (
      <thead>
        <tr>
          <th>
            <strong>{'งวดวันที่'}</strong>
          </th>
          <th>
            <strong>{'หมายเลข'}</strong>
          </th>
          <th>
            <strong>{'งวดที่'}</strong>
          </th>
          <th>
            <strong>{'ชุดที่'}</strong>
          </th>
          <th>
            <strong>โฟลเดอร์</strong>
          </th>
        </tr>
      </thead>
    )
  }

  const lotterylist = (order, info) => {
    return (
      <tr key={info?.id || order.id}>
        <td>{order.roundDate || '-'}</td>
        <td>{info?.number || '-'}</td>
        <td>{roundNoAndSeriesNo(info?.id)?.roundNo || '-'}</td>
        <td>{roundNoAndSeriesNo(info?.id)?.seriesNo || '-'}</td>
        <td>{info?.sourceBook || '-'}</td>
      </tr>
    )
  }

  const renderBody = () => {
    if (order && order.items) {
      const itemElems = order.items.map((item) => item.info.map((info) => lotterylist(order, info)))

      return <tbody>{itemElems}</tbody>
    }
  }

  const renderTable = () => {
    if (orderType === ORDER_ITEM_TYPE.BOX) {
      return order.items.map((item, index) => {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
            }}
            key={index}
          >
            <h4>
              กล่องสุ่มเลข#{item.number}:
              <span style={{ color: MYSTERY_BOX_ITEM[item.type].color }}>
                {MYSTERY_BOX_ITEM[item.type].name}:{MYSTERY_BOX_ITEM[item.type].count}ใบ
              </span>
              :<span>{BOX_PICKER_NAME[item.source]}</span>
            </h4>
            {item.isOpen ? (
              <Table responsive>
                {renderHeader()}
                <tbody>{item.info.map((info) => lotterylist(order, info))}</tbody>
              </Table>
            ) : (
              <Table responsive>
                {renderHeader()}
                <tbody>{item.info.map(() => lotterylist(order))}</tbody>
              </Table>
            )}
          </div>
        )
      })
    }

    return (
      <Table responsive>
        {renderHeader()}
        {renderBody()}
      </Table>
    )
  }

  return renderTable()
}
